import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { Box, Button, Stack, Typography } from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { NavLink } from 'react-router-dom';

import { appURL } from '../../Data/baseURL';
import { faqData } from './questionsAnswers';
import Answer from './Answer';
import {
  BackToHome,
  GlassCard,
  PublicContainer,
  PublicPage,
  PublicPageHero,
  publicPalette,
} from '../../Public/PublicLayout';

const Faq = () => {
  const { t, i18n } = useTranslation();
  const language = ['ro', 'ru', 'en'].includes(i18n.resolvedLanguage) ? i18n.resolvedLanguage : 'en';
  const questions = useMemo(() => faqData(), []);

  return (
    <PublicPage>
      <Helmet>
        <title>CONTDEPLATA — {t('faq.frequent_questions')}</title>
        <meta name="description" content={t('public.faq_meta', { defaultValue: 'Answers about online invoices, account setup, users, subscriptions, and document workflows.' })} />
      </Helmet>

      <PublicPageHero
        eyebrow={t('public.help_center', { defaultValue: 'Help center' })}
        title={t('public.faq_title', { defaultValue: 'Questions, answered clearly' })}
        description={t('public.faq_intro', { defaultValue: 'Find practical guidance about payment invoices, account configuration, subscriptions, users, and sending documents.' })}
        actions={<BackToHome />}
        compact
      />

      <Box sx={{ py: { xs: 7, md: 11 }, backgroundColor: publicPalette.background }}>
        <PublicContainer sx={{ maxWidth: 1000 }}>
          {questions.map((item) => (
            <Answer key={item.id} question={item[`question_${language}`]} answer={item[`answer_${language}`]} />
          ))}

          <GlassCard sx={{ mt: 5, p: { xs: 3, sm: 4 }, textAlign: 'center' }}>
            <Stack spacing={2} alignItems="center">
              <Typography component="h2" sx={{ color: publicPalette.text, fontSize: 26, fontWeight: 900 }}>{t('base.do_you_have_questions')}</Typography>
              <Typography sx={{ color: publicPalette.muted }}>{t('public.faq_support_text', { defaultValue: 'Our support team can help with account setup or a workflow that is not covered above.' })}</Typography>
              <Button component={NavLink} to={`${appURL}/support`} endIcon={<ArrowForwardRoundedIcon />} sx={{ color: publicPalette.primary, textTransform: 'none', fontWeight: 900 }}>{t('general.support')}</Button>
            </Stack>
          </GlassCard>
        </PublicContainer>
      </Box>
    </PublicPage>
  );
};

export default Faq;
